<template>
  <div>
    <v-btn small @click="dialog=!dialog" class="themed">Changer le mot de passe</v-btn>
    <v-dialog v-model="dialog" max-width="980px">
      <v-card>
        <v-toolbar>
          <v-toolbar-title>Changer le mot de passe</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-alert v-if="error" type="error">{{error}}</v-alert>

            <v-row>
              <v-col>
                <v-text-field
                  v-model="model.old_password"
                  type="password"
                  label="Mot de passe actuel"
                  hide-details="auto"
                  :rules="[mandatoryRules]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="model.password"
                  type="password"
                  label="Nouveau mot de passe"
                  hide-details="auto"
                  :rules="[mandatoryRules]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="model.repeat_password"
                  type="password"
                  label="Répeter le nouveau mot de passe"
                  hide-details="auto"
                  :rules="[mandatoryRules,passwordConfirmationRule]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="close()" class="themed">Fermer</v-btn>
          <v-spacer></v-spacer>
          <v-btn small @click="submit()" class="primary themed">Mettre à jour</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  data: () => ({
    model: {
      old_password: null,
      password: null,
      repeat_password: null
    },
    error: null,
    dialog: false,
    mandatoryRules: v => !!v || "Ce champ est obligatoire"
  }),
  computed: {
    ...mapGetters("auth", ["currentUser"]),
    passwordConfirmationRule() {
      return () =>
        this.model.password === this.model.repeat_password ||
        "Le mot de passe ne correspond pas";
    }
  },
  methods: {
    ...mapActions("auth", ["changePassword"]),
    submit() {
      this.changePassword(this.model)
        .then(() => {
          this.dialog = false;
        })
        .catch(error => {
          this.error = error.error;
        });
    },
    close() {
      this.dialog = false;
    },
    ...mapActions("stripes", ["sendTokenToServer"])
  }
};
</script>

<style>
</style>